function Input({ placeholder, title,value,changeValueHandler }) {
    return <div className="w-[90%] md:w-[30%] mb-7 relative mx-auto  border-2 p-2 border-solid rounded-[2px] border-[#14223D]">
        <input type="text" value={value} onChange={(e)=>changeValueHandler(e.target.value)} className="w-full outline-none" placeholder={placeholder} />
        <span className="absolute top-[-35%]  right-[10%] px-3 text-orange bg-white z-2">{title}</span>
    </div>
}

export default Input